import { IConsumptionsFilters } from '../../../models/Filters/ConsumptionsFilters';
import { ExportConsumptionByPractitionerId } from '../../../services/PractitionerConsumptions.Services';

export const ExportConsumptionByPractitionerWrapper = async (authToken: string, filters: IConsumptionsFilters, practitionerId: string): Promise<Blob> => {
    return await ExportConsumptionByPractitionerId(
        authToken,
        filters,
        practitionerId
    );
};